

export class EmployeeGroupEmployeeDetailsInput implements IEmployeeGroupEmployeeDetailsInput {
    /** The auto-generated id of the employee details master */
    employeeDetailsId!: number;

    constructor(data?: IEmployeeGroupEmployeeDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeDetailsId = _data["employeeDetailsId"];
        }
    }

    static fromJS(data: any): EmployeeGroupEmployeeDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupEmployeeDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeDetailsId"] = this.employeeDetailsId;
        return data; 
    }
}

export interface IEmployeeGroupEmployeeDetailsInput {
    /** The auto-generated id of the employee details master */
    employeeDetailsId: number;
}

